(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/hooks/use-task.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/hooks/use-task.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useCallback,
  useState,
  useEffect,
  useReducer
} = React;
function reducer(state) {
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case 'TASK_EXECUTE':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'pending'
      });
    case 'TASK_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'resolved',
        result: action.result
      });
    case 'TASK_FAILURE':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'rejected',
        error: action.error
      });
    case 'TASK_CANCEL':
      return {
        status: 'idle',
        result: null,
        error: null
      };
    default:
      throw new Error('Unknown action!');
  }
}
const initialState = {
  status: 'idle',
  result: null,
  error: null
};
function useTask() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [task, setTask] = useState(null);
  useEffect(() => {
    if (!task) {
      return;
    }
    dispatch({
      type: 'TASK_EXECUTE'
    });
    task.then(result => {
      if (!task.cancelled) {
        dispatch({
          type: 'TASK_SUCCESS',
          result
        });
      }
    }).catch(error => {
      if (!task.cancelled) {
        dispatch({
          type: 'TASK_FAILURE',
          error
        });
      }
    });
    return () => {
      var _task$cancel;
      (_task$cancel = task.cancel) === null || _task$cancel === void 0 || _task$cancel.call(task);
      task.cancelled = true;
    };
  }, [task]);
  const cancel = () => {
    setTask(null);
    dispatch({
      type: 'TASK_CANCEL'
    });
  };
  const run = useCallback(t => {
    setTask(t);
    return t;
  }, []);
  return _objectSpread(_objectSpread({}, state), {}, {
    run,
    cancel
  });
}
svs.ticket_partner.sharedComponents.hooks.useTask = useTask;

 })(window);